import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import qs from 'qs'
import router from './router'
import store from './vuex/store'
import { get, post, del, put, getDownload, postDownload ,postForm} from './http/index'
import methods from './methods/index'
import loading from './components/loading'

let localToken = window.localStorage.getItem('token'); // 获取本地token

if (!methods.isInvalid(localToken)) {
	store.commit('syncToken', localToken); // 更新token信息
}

// element ui
import {
	Button,
	Input,
	Radio,
	RadioGroup,
	RadioButton,
	Checkbox,
	CheckboxButton,
	CheckboxGroup,
	Select,
	Option,
	OptionGroup,
	Cascader,
	Table,
	TableColumn,
	MessageBox,
	Message,
	Notification,
	Tree,
	Pagination,
	DatePicker,
	TimeSelect,
	TimePicker,
	Dropdown,
	DropdownMenu,
	DropdownItem,
} from 'element-ui'


Vue.component('loading', loading);

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;
Vue.prototype.isInvalid = methods.isInvalid;

Vue.config.productionTip = false;


Vue.use(Button);
Vue.use(Input);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Cascader);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tree);
Vue.use(Pagination);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);

// Vue.use(HighchartsVue);

// Vue.prototype.Highcharts = Highcharts;
Vue.prototype.publicPath = process.env.BASE_URL;
Vue.prototype.$qs = qs;
Vue.prototype.del = del;
Vue.prototype.get = get;
Vue.prototype.getDownload = getDownload;
Vue.prototype.post = post;
Vue.prototype.postDownload = postDownload;
Vue.prototype.put = put;
Vue.prototype.postForm = postForm;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
